module.exports = __webpack_public_path__ + "images/kihnu/map.png";